import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheckIcon, XMarkIcon } from "@heroicons/react/24/outline";
import "./CookieConsent.css";

const COOKIE_CONSENT_KEY = "hardcoats-cookie-consent";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(window.localStorage.getItem(COOKIE_CONSENT_KEY) === null);
  }, []);

  const saveConsent = (choice) => {
    window.localStorage.setItem(COOKIE_CONSENT_KEY, choice);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-consent-backdrop">
      <aside className="cookie-consent" role="dialog" aria-labelledby="cookie-consent-title" aria-describedby="cookie-consent-description">
        <div className="cookie-consent__icon"><ShieldCheckIcon /></div>
        <div className="cookie-consent__content">
          <h2 id="cookie-consent-title">Your privacy matters</h2>
          <p id="cookie-consent-description">
            We use essential cookies to keep this website secure and functional.
            With your permission, we may also use optional cookies to understand
            how the site is used and improve your experience.
          </p>
          <div className="cookie-consent__links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/cookie-policy">Cookie Policy</Link>
          </div>
        </div>
        <div className="cookie-consent__actions">
          <button type="button" className="cookie-consent__reject" onClick={() => saveConsent("essential")}>Only essential</button>
          <button type="button" className="cookie-consent__accept" onClick={() => saveConsent("accepted")}>Accept all</button>
        </div>
        <button type="button" className="cookie-consent__close" aria-label="Continue with essential cookies" onClick={() => saveConsent("essential")}>
          <XMarkIcon />
        </button>
      </aside>
    </div>
  );
};

export default CookieConsent;
